import { createBrowserHistory } from "history";

export const hist = createBrowserHistory({});
